import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Button, ColorVariantEnum, IconPositionEnum, Text } from "@foleon/atomic";
import { FoleonIcon, IconType } from "../icons/Icons";

type HeaderProps = TitleContainerProps & DomainContainerProps;

type TitleContainerProps = {
	projectName: string;
};

type DomainContainerProps = {
	domain: string;
};

const TitleContainer = ({ projectName }: TitleContainerProps) => {
	return (
		<Flex gap="8px" color="white">
			<Text.Title colorVariant={ColorVariantEnum.WHITE}>{projectName}</Text.Title>
			<FoleonIcon iconType={IconType.WHITE_PEN} />
		</Flex>
	);
};

const DomainContainer = ({ domain }: DomainContainerProps) => {
	return (
		<Flex direction="column" pt="10px">
			<Box mb="-15px">
				<Text.Paragraph colorVariant={ColorVariantEnum.LIGHT}>Domain</Text.Paragraph>
			</Box>
			<Text.Paragraph colorVariant={ColorVariantEnum.WHITE}>{domain}</Text.Paragraph>
		</Flex>
	);
};

export const Header = ({ projectName, domain }: HeaderProps) => {
	return (
		<Flex
			borderRadius="4px"
			color="white"
			backgroundColor="RGB(0, 25, 69)"
			h={["auto", "254px"]}
			maxW="1090px"
			w="100%"
			p="30px"
			direction="column"
			gap="10px"
		>
			<TitleContainer projectName={projectName} />
			<Flex gap={["10px", "30px"]} direction={["column", "row"]}>
				<FoleonIcon iconType={IconType.FOLDER} />
				<Flex direction="column">
					<DomainContainer domain={domain} />
					<Button
						iconPosition={IconPositionEnum.LEFT}
						icon={() => <FoleonIcon iconType={IconType.SETTINGS}
						/>}
					>
						Project Settings
					</Button>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default Header;